import type { StatsBandContent } from "@/types/report";

interface Props {
  content: StatsBandContent;
}

export function StatsBandSection({ content }: Props) {
  return (
    <div className="report-stats-band">
      {content.stats.map((stat, i) => {
        const trendClass =
          stat.trend === "up"
            ? "trend-up"
            : stat.trend === "down"
              ? "trend-down"
              : "";

        return (
          <div key={i} className="report-stat-item">
            <div className={`report-stat-value ${trendClass}`}>
              <span className="report-stat-number">{stat.value}</span>
              {stat.trendValue && (
                <span className="report-stat-trend">
                  {stat.trendValue}
                </span>
              )}
              {stat.delta && !stat.trendValue && (
                <span className="report-stat-trend">
                  {stat.delta}
                </span>
              )}
            </div>
            <div className="report-stat-label">{stat.label}</div>
          </div>
        );
      })}
    </div>
  );
}
